export const CONFIRM_EMAIL_CODE_LENGTH = 6;
